import { render } from "./BadgeEditorDialog.vue?vue&type=template&id=c139de42&scoped=true"
import script from "./BadgeEditorDialog.vue?vue&type=script&lang=js"
export * from "./BadgeEditorDialog.vue?vue&type=script&lang=js"

import "./BadgeEditorDialog.vue?vue&type=style&index=0&id=c139de42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c139de42"]])

export default __exports__